import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport, withXsrfConfiguration } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaderService } from './providers/core-interceptor/loader.service';
import { InterceptorService } from './providers/core-interceptor/core-interceptor.service';
import { SharedModule } from './shared/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgIdleModule } from '@ng-idle/core';
import { CredentialsInterceptor } from './providers/auth-session/credentials.interceptor';
import { AUTH_CSRF } from './providers/auth-session/auth-session.constants';

@NgModule(
  {
    declarations: [
      AppComponent
    ],
    bootstrap: [
      AppComponent
    ],
    imports: [
      SharedModule,
      BrowserModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      NgxSpinnerModule,
      ServiceWorkerModule.register('ngsw-worker.js',
        {
          // 127.0.0.1 is added for local development work.
          enabled: environment.production && !['localhost', '127.0.0.1'].includes(window.location.hostname),
          registrationStrategy: 'registerWhenStable:30000'
        }),
      NgIdleModule.forRoot(),
      NgMultiSelectDropDownModule.forRoot()
    ],
    providers: [
      LoaderService,
      {
        // Session cookie + CSRF header for API calls (must run before the spinner/error interceptor).
        provide: HTTP_INTERCEPTORS,
        useClass: CredentialsInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: InterceptorService,
        multi: true
      },
      provideHttpClient(
        withInterceptorsFromDi(),
        withJsonpSupport(),
        withXsrfConfiguration({ cookieName: AUTH_CSRF.cookieName, headerName: AUTH_CSRF.headerName })
      )
    ]
  })

export class AppModule { }
